import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SiteLayout from './components/layout/SiteLayout';
import ScrollManager from './components/common/ScrollManager';
import ErrorBoundary from './components/common/ErrorBoundary';
import ROUTES from './utils/routes';

/**
 * Route-level code splitting.
 *
 * Each page is loaded on demand, so the first paint ships the shell and the
 * page in front of the visitor rather than everything the site will ever need.
 *
 * Unknown paths redirect to the home page rather than rendering a 404 document:
 * the site is deliberately two pages, and CloudFront's single-page-app fallback
 * serves index.html for any unmatched path, so a third "not found" page would
 * exist only to apologise. A visitor who mistypes a URL still lands somewhere
 * useful.
 */
const HomePage = lazy(() => import('./pages/HomePage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));

/**
 * Application root.
 *
 * Hosting must map unknown paths back to index.html for client-side routing.
 * On the S3 + CloudFront deployment that is the distribution's custom error
 * response (403 and 404 -> /index.html with a 200 status) -- see the Deployment
 * section of README.md.
 */
const App = () => (
  <>
    <ScrollManager />
    <ErrorBoundary>
      <Suspense
        fallback={
          <p className="route-loading" role="status">
            Loading…
          </p>
        }
      >
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path={ROUTES.home} element={<HomePage />} />
            <Route path={ROUTES.services} element={<ServicesPage />} />
            <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
          </Route>
        </Routes>
      </Suspense>
    </ErrorBoundary>
  </>
);

export default App;
